import { useContext } from "react";
import { StreamingContext, type StreamingContextType } from "@/shared/contexts/StreamingContext";

export function useStreaming(): StreamingContextType {
    const context = useContext(StreamingContext);
    if (context === undefined) {
        throw new Error("useStreaming must be used within a StreamingProvider");
    }
    return context;
}

export function useStreamingOptional(): StreamingContextType | undefined {
    return useContext(StreamingContext);
}
